module.exports = __webpack_public_path__ + "img/Loss analysis - hubspot.8e71ca46.gif";